import React from "react";
import ReactDOM from "react-dom/client";
import "./Css/index.css";
import App from "./App";
import { ThemeProvider } from "./Components/DarkMode/ThemeProvider";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import UserContext from "./Contexts/UserContext";

import Provider from './Provider'

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <UserContext>
          <Provider>
            <App />
          </Provider>
        </UserContext>
      </QueryClientProvider>
    </ThemeProvider>
  </BrowserRouter>
);
